interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, totalPages: number): (number | "...")[] {
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  const pages: (number | "...")[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  if (start > 2) pages.push("...");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < totalPages - 1) pages.push("...");
  pages.push(totalPages);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(page, totalPages);

  const baseBtn =
    "inline-flex h-9 min-w-9 cursor-pointer items-center justify-center rounded-md border px-2 font-label text-sm transition-colors";

  return (
    <nav className="mt-8 flex items-center justify-center gap-1.5" aria-label="分页导航">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className={`${baseBtn} border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40`}
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg" aria-hidden="true" />
      </button>
      {pages.map((item, idx) =>
        item === "..." ? (
          <span key={`gap-${idx}`} className="px-1 text-sm text-foreground-400">
            …
          </span>
        ) : (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            aria-current={item === page ? "page" : undefined}
            className={`${baseBtn} ${
              item === page
                ? "border-primary-500 bg-primary-500 text-background-50"
                : "border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {item}
          </button>
        ),
      )}
      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className={`${baseBtn} border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40`}
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg" aria-hidden="true" />
      </button>
    </nav>
  );
}